(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kw-fields"] && !Shopify.designMode) return;
  try {
    (() => {
  const sync = group => {
    const later = group.querySelector('[data-kw-photo-choice]:checked')?.value === 'Send Later';
    const input = group.querySelector('[data-kw-photo]');
    input.required = false;
    input.disabled = later;
    group.querySelector('[data-kw-photo-upload]').hidden = later;
    group.querySelector('[data-kw-photo-later]').hidden = !later;
  };
  const init = root => root.querySelectorAll('[data-kw-photo-choice-group]').forEach(sync);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-kw-photo-choice]')) return;
    const group = event.target.closest('[data-kw-photo-choice-group]');
    if (group) sync(group);
  });
  document.addEventListener('formdata', event => {
    const group = event.target.querySelector('[data-kw-photo-choice-group]');
    if (!group) return;
    const input = group.querySelector('[data-kw-photo]');
    if (input.disabled || !input.files.length) {
      event.formData.delete(input.name);
      event.formData.set('properties[Pet photo]', 'Send Later');
      event.formData.set('properties[_Photo Submission]', 'Send Later');
    } else {
      event.formData.delete('properties[Pet photo]');
      event.formData.set('properties[_Photo Submission]', 'Uploaded');
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => init(document));
})();
  } catch(e) { console.error(e); }
})();

})();
